<template>
  <div class="payment__content">
    <!-- header -->
    <div class="layer__header">
      <div class="lyr-title">{{ $t('User.Pickup.PickupCheck.msg1') }}</div>
      <div class="ft-point">
        {{ $t('User.Pickup.PickupCheck.msg2') }}
      </div>
      <div class="lyr-txt">{{ $t('User.Pickup.PickupCheck.msg3') }}</div>
    </div>
    <!-- //header -->
    <div class="payment__body">
      <div class="inner-pd">
        <span class="img-info img--check"></span>
      </div>
    </div>

    <div class="layer__button">
      <button class="btn btn--half btn--cancel btn-anim" @mouseup="$emit('closeCheck')">{{ $t('User.Pickup.PickupCheck.msg8') }}</button>
      <button class="btn btn--half btn--submit btn-anim" @mouseup="$emit('setFinish')">{{ $t('User.Pickup.PickupCheck.msg9') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pickupCheck',
  props: {},
  methods: {},
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {
    this.$changeDarkMode(this.darkModeYn);
    this.$showButtonAnimation();
  },
  components: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped></style>
